<template>
  <div class="component-container">

    <div class="second-edition" id="second-edition">
      <h3>2LNG Second Edition: Plant and Animal Relationships - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      
      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F2LNG-2E_Activities_1-6_08212024.zip?alt=media&token=929c7013-019d-4003-a835-7d90d2fec5b7" target="_blank">Teacher Presentations: Activities 1 - 6</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/18uTKQDYndvnKyldeilkZxvOJ2Fx3Uf2iR5oA1Cv-zzQ/copy" target="_blank">2LNG Second Edition: Plant and Animal Relationships Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1jBm0XAhR78syQD_IU1OWA8cVkFhD7gGO/view" target="_blank">2LNG Second Edition: Plant and Animal Relationships Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1-kD2r30vj7Ebd7wYcBX6OZFk6jO6LPgOeXq7PeCqhlQ/copy" target="_blank">2LNG Second Edition: Plant and Animal Relationships Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2LNG-2E_PostAssessment_05042022.pdf?alt=media&token=42737b6c-dfbe-4a91-8fd4-3d2b06c2d8d4" target="_blank">2LNG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2LNG-2E_Spanish_PostAssessment_06102022.pdf?alt=media&token=23af2a6b-71dd-4778-8229-32d8122771f1" target="_blank">2LNG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1MOJwhuu2wyreYcpPz3V-N5Th_O2LLCoB5-F-YOLNJoM/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1_EoT-cAeQP0_LLVXI8wiCuIiEN3gW-ukJw_FRv8vF4o/copy" target="_blank">Word Sort Cards - Lesson 1C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1UvNeDILBCNBvsJ3dVybNgpFlDm_9GxJXG6C8kLo9dAk/copy" target="_blank">Nature Picture Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1EpAhIjdpL6GF-o9LbtNVXeVZv3CfFIz9hCePZ5wIDvg/copy" target="_blank">Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1CtWzLnQg1EUpeObNmsQW8v5YmxRbZ-q1dRkiv55rfqk/copy" target="_blank">2LNG Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1CsV6W_SfXdTUdWaCTBD30L45zGtqUAsMJ0fhJJuKeMU/copy" target="_blank">Schoolyard Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1GW8oJYfakuBBNJOBBBu_eFuigiNgZ_bdK5rksgwmF0s/copy" target="_blank">Word Sort Cards - Lesson 2B</a></li>
          <li><a href="https://docs.google.com/presentation/d/11AC9J2CSwQVV0KlVxp1mV_h9HPsrbHzoZKORlqwPxW4/copy" target="_blank">Writing a Scientific Explanation for Our Investigation</a></li>
          <li><a href="https://docs.google.com/presentation/d/1JbaI1Hbog0q0rlgVyuUhTlte_JADHBZq8xshkBSvH_U/copy" target="_blank">Patterns in Our Data chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/12atFduCH1oA72EMBFQmWEVVp5AEnSIMWWXEAUk3fEN8/copy" target="_blank">Sorting Seeds</a></li>
          <li><a href="https://docs.google.com/presentation/d/1fdwPpMPa2R90tdsRXwll9ZWoGdm1sBbS5qivMV2bY0E/copy" target="_blank">Seed Dispersal Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/164_hnYtFNi4iAJJPw9y5fed7l2MwUq18y2ZRK8UPqK4/copy" target="_blank">Seed Stations (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ltsvEJzbclRI253lJ-tZdT4PJNy097TVAypHbDfPvlg/copy" target="_blank">The Way Seeds Are Dispersed</a></li>
          <li><a href="https://docs.google.com/presentation/d/19NgzqcRpBXwUkKy2VsJvE0Tf8Wk2amozOolVUgOA928/copy" target="_blank">Seed Model Product Descriptor</a></li>
          <li><a href="https://docs.google.com/document/d/1OnxU9kkSAUTVXCB9XUCJ5tG8a6lMCHs0TeHcLr9biO8/copy" target="_blank">Apple Blossom Model Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Qu1z8HedmqCtWoqduOQtqMavaQqzPurhCVZD7kQjMGQ/copy" target="_blank">Word Sort Cards - Lessons 6B,6C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1-D2v7FiYNKK14NR5YYAgOmrQ6u4hhzGgi5e3R5221cs/copy" target="_blank">Achoo! Animals and Pollen Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1GWBu_DRn03sXrNpAVx3SSP_lUjzsE9hkMiowzp4pC50/copy" target="_blank">Flower Anatomy and Bee Anatomy (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1xUyVU_Ida-jSomneLpB0CArd-LZ5Wnhd9KhKj2vUu0o/copy" target="_blank">Hand Pollinator Product Descriptor (Handout)</a></li>
          
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
